import React, { VoidFunctionComponent, useRef, useState } from "react";
import Slider, { Settings } from "react-slick";
import { RenderImageThumbnail } from "@/components/responsive/product/renderImageThumbnail/RenderImageThumbnail";
import { ArrowButton } from "@/components/responsive/commun/arrowButton/ArrowButton";
import {
    MAX_IMAGES_BEFORE_LAZY_LOADING,
    SLIDER_MAX_IMAGES_TO_DISPLAY,
} from "@/utils/constants";
import {TagsInsideImage} from "@/components/responsive/product/productImageGrid/TagsInsideImage";
import { ProductFeature } from "@/models/scope/productSheet/ProductFeature";
import {CommercialOperations} from "@/models/scope/productSheet/CommercialOperations";
import {Offers} from "@/models/scope/productSheet/offer/Offers";
import {ProductDocumentList} from "@/models/scope/productSheet/ProductDocumentList";

interface Props {
    medias: string[];
    setIndexToShow: (indexToShow: number) => void;
    setIsSliderModalShow: (status: boolean) => void;
    isVideoIconDisplayed: (index: number) => boolean;
    documentId: ProductDocumentList<string> | null,
    openVideoPlayer: (index: number) => void;
    videoUrl?: string;
    positionVideo1?: number;
    alt: string;
    newEnergyClass: string|null;
    repairabilityIndex: string;
    commercialOperations: CommercialOperations[];
    soldBy: string;
    eligibilityToPrivateSale: boolean;
    offersData: Offers | null;
    features: ProductFeature[];
}

export const ProductImageMobile: VoidFunctionComponent<Props> = ({
    medias,
    setIndexToShow,
    setIsSliderModalShow,
    isVideoIconDisplayed,
    alt,
    documentId,
    openVideoPlayer,
    videoUrl,
    positionVideo1,
    newEnergyClass,
    repairabilityIndex,
    commercialOperations,
    soldBy,
    eligibilityToPrivateSale,
    offersData,
    features,
}) => {
    const [activeSlide, setActiveSlide] = useState(0);
    let customSlider = useRef<Slider>(null);
    const mediasCount = medias?.length;
    const maxDisplayedImage = mediasCount > SLIDER_MAX_IMAGES_TO_DISPLAY ? SLIDER_MAX_IMAGES_TO_DISPLAY : mediasCount;
    const sliderSettings: Settings = {
        slidesToShow: 1,
        infinite: false,
        speed: 500,
        slidesToScroll: 1,
        arrows: false,
        lazyLoad: "anticipated",
        beforeChange: (currentSlide: number, nextSlide: number) => setActiveSlide(nextSlide),
    };

    return (
        <div className="slider-block">
            <ArrowButton
                onClick={() => customSlider.current?.slickPrev?.()}
                isDisable={activeSlide === 0}
                isRotated={true}
            />
            <ArrowButton
                onClick={() => customSlider.current?.slickNext?.()}
                isDisable={
                    activeSlide === maxDisplayedImage - 1
                }
                isRotated={false}
            />
            <div className="slider-container">
                <Slider
                    ref={(slider) => (customSlider = {
                        ...customSlider,
                        current: slider,
                    })}
                    {...sliderSettings}
                >
                    {medias?.slice(0, SLIDER_MAX_IMAGES_TO_DISPLAY).map((image, i) => {
                        return (
                            <RenderImageThumbnail
                                key={i}
                                image={image}
                                alt={alt}
                                className="mobile-slick"
                                onClick={() => {
                                    setIndexToShow(i);
                                    setIsSliderModalShow(true);
                                }}
                                isLazy={i >= MAX_IMAGES_BEFORE_LAZY_LOADING}
                                isVideoIconDisplayed={isVideoIconDisplayed(i)}
                                openVideoPlayer={() => openVideoPlayer(i)}
                            >
                                {i === 0 && videoUrl && positionVideo1 ? (
                                    <div className="video-sidebar" onClick={() => openVideoPlayer(positionVideo1)}>
                                        <img src={"/assets/images/responsive/icons/triangleWhite.svg"} alt="play icone" />
                                        <p>Vidéo</p>
                                    </div>
                                ) : <></>}
                                {i === 0 ? (
                                    <TagsInsideImage
                                        commercialOperations={commercialOperations}
                                        newEnergyClass={newEnergyClass}
                                        reparabilityIndex={repairabilityIndex}
                                        documentId={documentId}
                                        elibiblitySoldBy={['BUT', 'BUT_MKP']}
                                        eligibilityToPrivateSale={eligibilityToPrivateSale}
                                        soldBy={soldBy}
                                        offersData={offersData}
                                        features={features}
                                    />
                                ) : <></>}
                            </RenderImageThumbnail>
                        );
                    })}
                </Slider>
                {typeof window === 'undefined' &&
                    <RenderImageThumbnail
                        image={medias[0]}
                        alt={alt}
                        className="mobile-slick"
                        onClick={() => {
                            setIndexToShow(0);
                            setIsSliderModalShow(true);
                        }}
                        isLazy={false}
                        isVideoIconDisplayed={isVideoIconDisplayed(0)}
                        openVideoPlayer={()=>{}}
                    >
                        {!!videoUrl ? (
                            <div className="video-sidebar" >
                                <img src={"/assets/images/responsive/icons/triangleWhite.svg"} alt="play icone" />
                                <p>Vidéo</p>
                            </div>
                        ) : <></>}
                    </RenderImageThumbnail>}
            </div>
            <div className="counter">
                {mediasCount > 1 && <p>{`${activeSlide + 1}/${maxDisplayedImage}`}</p>}
            </div>
        </div>
    )
}